import { Link } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";

export const Terms = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <div className="container px-4 pt-32 pb-16 max-w-4xl">
        <div className="prose prose-invert max-w-none">
          <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4">Last Updated: January 6, 2026</h2>
              <p className="text-muted-foreground">
                Welcome to Sharpexio. These Terms of Service ("Terms") govern your use of our cryptocurrency portfolio analytics platform and related services. By accessing or using Sharpexio, you agree to be bound by these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground">
                By accessing and using Sharpexio, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use our service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Description of Service</h2>
              <p className="text-muted-foreground">
                Sharpexio is a cryptocurrency portfolio analytics platform that provides insights, metrics, and analysis tools for trading activities. Our service connects to blockchain networks and cryptocurrency exchanges to fetch and analyze trading data.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Important Disclaimers</h2>
              
              <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-6 mb-6">
                <h3 className="text-xl font-semibold text-destructive mb-3">⚠️ Critical Risk Disclaimer</h3>
                <ul className="space-y-2 text-muted-foreground">
                  <li><strong>NOT FINANCIAL ADVICE:</strong> Sharpexio is not a financial advisor, investment advisor, or registered broker-dealer. The information provided on our platform is for informational and educational purposes only.</li>
                  <li><strong>NO TRADING RECOMMENDATIONS:</strong> We do not provide buy, sell, or hold recommendations for any cryptocurrency or trading strategy.</li>
                  <li><strong>TRADING AT YOUR OWN RISK:</strong> All trading decisions are made at your own will and risk. You are solely responsible for any financial losses incurred.</li>
                  <li><strong>SHARPEXIO NOT RESPONSIBLE:</strong> Sharpexio is not responsible for any trading losses, financial damages, or losses resulting from the use of our platform.</li>
                  <li><strong>PAST PERFORMANCE:</strong> Past performance does not guarantee future results. Historical data and analytics are not indicative of future performance.</li>
                </ul>
              </div>

              <p className="text-muted-foreground">
                Cryptocurrency trading involves substantial risk of loss and is not suitable for all investors. You should carefully consider whether trading is appropriate for you in light of your financial condition, investment objectives, and risk tolerance.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. User Responsibilities</h2>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>Maintain the security of your wallet and private keys</li>
                <li>Ensure all trading decisions are made independently</li>
                <li>Verify all information before making trading decisions</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Not use Sharpexio for any illegal or unauthorized activities</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Data and Analytics</h2>
              <p className="text-muted-foreground">
                Sharpexio provides analytics and insights based on blockchain data and exchange information. While we strive for accuracy, we cannot guarantee the completeness, timeliness, or accuracy of all data. Market conditions can change rapidly, and data may contain errors or omissions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Wallet Connections</h2>
              <p className="text-muted-foreground">
                Sharpexio uses read-only wallet connections via WalletConnect and similar protocols. We never request or store private keys, and we cannot execute trades on your behalf. You maintain full control over your wallet and assets at all times.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Limitation of Liability</h2>
              <p className="text-muted-foreground">
                To the maximum extent permitted by law, Sharpexio shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Indemnification</h2>
              <p className="text-muted-foreground">
                You agree to indemnify and hold Sharpexio and its affiliates harmless from any claim or demand, including reasonable attorneys' fees, made by any third-party due to or arising out of your breach of these Terms or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Service Availability</h2>
              <p className="text-muted-foreground">
                Sharpexio does not guarantee uninterrupted or error-free service. We may experience downtime, maintenance periods, or technical issues. We are not liable for any losses resulting from service interruptions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">10. Modifications to Terms</h2>
              <p className="text-muted-foreground">
                We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of the service constitutes acceptance of any modified Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">11. Termination</h2>
              <p className="text-muted-foreground">
                We may terminate or suspend your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">12. Contact Information</h2>
              <p className="text-muted-foreground">
                If you have any questions about these Terms, please contact us at:
              </p>
              <div className="bg-muted/50 rounded-lg p-4 mt-4">
                <p>Email: legal@sharpex.io</p>
                <p>Website: https://sharpex.io</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">13. Governing Law</h2>
              <p className="text-muted-foreground">
                These Terms shall be interpreted and governed by the laws of the jurisdiction in which Sharpexio operates, without regard to conflict of law provisions.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground text-center">
              <Link to="/" className="text-primary hover:underline">← Back to Home</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
